"use client";

import Image from "next/image";
import Link from "next/link";

import {FileProps} from "@/types";

import api from "@/lib/api";

export default function GettingStarted() {
  const handlePDFClick = async () => {
    try {
      const response = await api.get<FileProps>("/files/qjhffmnj/");

      const pdfUrl = response.url;

      if (pdfUrl) {
        window.open(pdfUrl, "_blank");
      } else {
        alert("PDF not found");
      }
    } catch (error: any) {
      console.error("Error fetching PDF:", error);
      alert("Failed to fetch PDF link. Please try again later.");
    }
  };

  return (
    <>
      <p className='g2-text-grey'>
        Find out more about all the features of the Gateway COVID site or
        download our brochure. <br />
        <b>The Gateway to Global Aging COVID Data</b> provides extensive
        information about the COVID-19 interviews conducted by the network of
        Health and Retirement Studies.
      </p>
      <h4 className='g2-header-navy'>The Gateway Features</h4>
      <hr />
      <p className='g2-text-grey'>
        <Link
          href='/health-and-retirement-studies/overview'
          className='fw-bold g2-link-blue'
        >
          STUDY OVERVIEWS
        </Link>{" "}
        Learn about each study with either a separate COVID-19 interview or with
        COVID-19 specific interview modules in the International Network of
        Health and Retirement Studies
      </p>
      <p className='g2-text-grey'>
        <Link
          href='/health-and-retirement-studies/questionnaire'
          className='fw-bold g2-link-blue'
        >
          SURVEY QUESTIONNAIRES
        </Link>{" "}
        View COVID survey questionnaires from each interview round of each study
      </p>
      <p className='g2-text-grey'>
        <Link
          href='/health-and-retirement-studies/search'
          className='fw-bold g2-link-blue'
        >
          QUESTIONNAIRE SEARCH
        </Link>{" "}
        Search for relevant survey questions from all studies by keyword
      </p>

      <p className='g2-text-grey'>
        <Link
          href='/health-and-retirement-studies/get-data'
          className='fw-bold g2-link-blue'
        >
          GET SURVEY DATA
        </Link>{" "}
        Get access to COVID survey data
      </p>
      <p className='g2-text-grey'>
        <Link
          href='/harmonized-covid-data/overview'
          className='fw-bold g2-link-blue'
        >
          HARMONIZED DATA OVERVIEWS
        </Link>{" "}
        Get information about each of our Harmonized COVID datasets
      </p>
      <p className='g2-text-grey'>
        <Link
          href='/harmonized-covid-data/get-data'
          className='fw-bold g2-link-blue'
        >
          GET HARMONIZED DATA
        </Link>{" "}
        Get access to Harmonized COVID data
      </p>
      <p className='g2-text-grey'>
        <Link
          href='/additional-covid-resources/publications'
          className='fw-bold g2-link-blue'
        >
          PUBLICATIONS
        </Link>{" "}
        Find topic and study specific COVID-19 publications
      </p>
      <p className='g2-text-grey'>
        <a
          href='mailto:help@g2aging.org'
          className='fw-bold g2-link-blue'
          target='_blank'
        >
          HELP DESK
        </a>{" "}
        Email any questions you might have!
      </p>

      <h4 className='g2-header-navy mt-5'>GATEWAY Covid Brochure</h4>
      <hr />
      <p>
        <Image
          alt='COVID Brochure'
          width='300'
          height='350'
          src='/covid_brochure.png'
          onClick={handlePDFClick}
          style={{
            border: "1px solid #bbb9b5",
            cursor: "pointer",
          }}
        />
      </p>

      <h4 className='g2-header-navy'>Other Links For Getting Started</h4>
      <hr />
      <p className='g2-text-grey'>
        <Link href='/help/faqs' className='fw-bold g2-link-blue'>
          FREQUENTLY ASKED QUESTIONS
        </Link>{" "}
        See answers to frequently asked questions by Gateway users
      </p>
    </>
  );
}
